import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllEmployee, getCompanys } from '../../services/dataService';
import toast from 'react-hot-toast';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getSecureItem } from '../../services/SecureStorage';


function NonWorkingEmp() {
  const [workingEmployees, setWorkingEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedProfitCenter, setSelectedProfitCenter] = useState('');
  const [companyDetails, setCompanyDetails] = useState([])


  const navigate = useNavigate();

  const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const Dep = departmentIds.split(",")[0] || null;
  const isAdmin = getSecureItem("IsAdmin");
  // Mock UID - replace with actual UID from your auth context
  const UID = getSecureItem("userId");


  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanys(UID);
      setCompanyDetails(response.data.data[0])
      console.log(response.data.data[0], 'Respocsdnse Data');

    } catch (error) {
      console.error('An error occurred:', error);
      toast.error('An error occurred while fetching company details');
    }
  };

  useEffect(() => {
    fetchCompanyDetails()
  }, [])
  const getWorkingEmployees = async () => {
    try {
      setLoading(true);
      const response = await getAllEmployee(UID);
      const datas =
        isAdmin == 1
          ? response.data.data
          : response.data.data.filter((el) => el?.DepartmentId == Dep);
      const filteredData = datas.filter((el) => el.EmpStatusName !== 'Working');
      console.log(filteredData, 'Working Employees Data');
      setWorkingEmployees(filteredData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWorkingEmployees();
  }, []);

  // Get unique departments and profit centers for filter options
  const departments = useMemo(() => {
    const uniqueDepts = [...new Set(workingEmployees.map(emp => emp.DepartmentName))];
    return uniqueDepts.filter(dept => dept).sort();
  }, [workingEmployees]);

  const profitCenters = useMemo(() => {
    const uniqueCenters = [...new Set(workingEmployees.map(emp => emp.ProfitCenterName))];
    return uniqueCenters.filter(center => center).sort();
  }, [workingEmployees]);

  // Filter employees based on search and filters
  const filteredEmployees = useMemo(() => {
    return workingEmployees.filter(employee => {
      const matchesSearch = searchTerm === '' ||
        employee.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        employee.Code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        employee.DesignationName?.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesDepartment = selectedDepartment === '' ||
        employee.DepartmentName === selectedDepartment;

      const matchesProfitCenter = selectedProfitCenter === '' ||
        employee.ProfitCenterName === selectedProfitCenter;

      return matchesSearch && matchesDepartment && matchesProfitCenter;
    });
  }, [workingEmployees, searchTerm, selectedDepartment, selectedProfitCenter]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  const handleBackToDashboard = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-lg text-gray-600">Loading employees...</p>
        </div>
      </div>
    );
  }

  const handleDownloadPDF = (companyDetails) => {
    console.log(companyDetails, 'jsjsj');

    if (filteredEmployees.length === 0) {
      toast.error("Nothing to Print");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });

    // Title
    doc.setFontSize(22);
    doc.setTextColor("#000");
    doc.text(companyDetails ? companyDetails.Name : '', 210, 20, { align: 'center' });
    // Subtitle
    doc.setFontSize(16);
    doc.text("Not Working Employees", 210, 30, { align: "center" });

    // Group employees by department
    const groupedData = filteredEmployees.reduce((acc, employee) => {
      const department = employee.DepartmentName || "Unknown Department";
      if (!acc[department]) acc[department] = [];
      acc[department].push(employee);
      return acc;
    }, {});

    let startY = 40;

    Object.keys(groupedData).forEach((department, index) => {
      // Add department subheading
      doc.setFontSize(14);
      doc.setTextColor("#000");
      doc.setFont(undefined, 'bold');
      doc.text(department, 25, startY);
      doc.setFont(undefined, 'normal');
      startY += 8;


      // Create table with explicit column configuration
      doc.autoTable({
        columns: [
          { header: 'Sl. No', dataKey: 'slNo' },
          { header: 'Code', dataKey: 'code' },
          { header: 'Name', dataKey: 'name' },
          { header: 'Profit Center', dataKey: 'profitCenter' },
          { header: 'Designation', dataKey: 'designation' },
          { header: 'Mobile', dataKey: 'mobile' }
        ],
        body: groupedData[department].map((employee, idx) => ({
          slNo: idx + 1,
          code: employee.Code || '',
          name: employee.Name || '',
          profitCenter: employee.ProfitCenterName || '',
          designation: employee.DesignationName || '',
          mobile: employee.Mobile || ''
        })),
        startY,
        tableWidth: 370, // Fixed table width to prevent extra columns
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          halign: "center",
          valign: "middle",
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        bodyStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          halign: "center",
          valign: "middle",
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
        },
        columnStyles: {
          slNo: { cellWidth: 25, halign: 'center' },
          code: { cellWidth: 35, halign: 'center' },
          name: { cellWidth: 100, halign: 'left' },
          profitCenter: { cellWidth: 80, halign: 'center' },
          designation: { cellWidth: 80, halign: 'center' },
          mobile: { cellWidth: 50, halign: 'center' }
        },
        margin: { left: 25, right: 15 },
        styles: {
          fontSize: 9,
          cellPadding: 3,
          overflow: 'linebreak',
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
        },
        tableLineWidth: 0.5,
        tableLineColor: [0, 0, 0],
        theme: 'grid',
        showFoot: 'never', // Ensure no footer
        showHead: 'everyPage', // Show header on every page
        willDrawCell: function (data) {
          // Hide any column beyond index 5 (Mobile is index 5)
          if (data.column.index > 5) {
            return false; // Don't draw this cell
          }
        }
      });

      // Update the startY position for the next department
      startY = doc.lastAutoTable.finalY + 12;

      // Add page break if needed
      if (startY > 270 && index < Object.keys(groupedData).length - 1) {
        doc.addPage();
        startY = 20;
      }
    });

    // Save PDF
    doc.save("Not_Working_Employees_Grouped.pdf");
  };

  return (
    <div className="p-4">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Not Working Employees</h1>
        {isAdmin == 0 && filteredEmployees?.length > 0 && (
          <>
            {console.log(isAdmin, 'hshshs')}
            <p className="text-2xl text-gray-800">
              Department: {[...new Set(filteredEmployees.map((el) => el.DepartmentName))].join(", ")}
            </p>
          </>
        )}

        <div className="ml-auto flex gap-4">
          <button
            onClick={handleBackToDashboard}
            className="bg-blue text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
          >
            ← Back to Dashboard
          </button>
          <button
            onClick={() => handleDownloadPDF(companyDetails)}
            className="btn btn-danger"
          >
            Download PDF
          </button>
        </div>
      </div>


      {/* Filters and Count in Single Row */}
      <div className="flex flex-wrap items-center gap-4 mb-6 bg-gray-50 p-4 rounded">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700">Total:</span>
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
            {filteredEmployees.length} of {workingEmployees.length}
          </span>
        </div>

        <input
          type="text"
          placeholder="Search by name, code, or designation..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 min-w-64 px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
        />
        {isAdmin == 1 &&
          <select
            value={selectedDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500 bg-white"
          >
            <option value="">All Departments</option>
            {departments.map((dept, index) => (
              <option key={index} value={dept}>{dept}</option>
            ))}
          </select>}

        <select
          value={selectedProfitCenter}
          onChange={(e) => setSelectedProfitCenter(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500 bg-white"
        >
          <option value="">All Profit Centers</option>
          {profitCenters.map((center, index) => (
            <option key={index} value={center}>{center}</option>
          ))}
        </select>

        {(searchTerm || selectedDepartment || selectedProfitCenter) && (
          <button
            onClick={() => {
              setSearchTerm('');
              setSelectedDepartment('');
              setSelectedProfitCenter('');
            }}
            className="px-3 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
          >
            Clear
          </button>
        )}
      </div>

      {/* Simple Full Width Table */}
      <div className="w-full overflow-x-auto">
        {filteredEmployees.length === 0 ? (
          <div className="text-center py-12 bg-white rounded border">
            <p className="text-gray-500 text-lg">No employees found</p>
          </div>
        ) : (
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Sl No.</th>
                <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Employee Name</th>
                <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Code</th>
                <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Mobile</th>
                <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Email</th>
                <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Designation</th>
                {isAdmin == 1 &&
                  <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Department</th>}
                <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Profit Center</th>
                <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">DOJ</th>
                <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">Category</th>
              </tr>
            </thead>
            <tbody>
              {filteredEmployees.map((employee, index) => (
                <tr key={employee.Id} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-4 py-3 text-gray-900">
                    {index + 1}
                  </td>
                  <td className="border border-gray-300 px-4 py-3 text-gray-900 font-medium">
                    {employee.Name || 'N/A'}
                  </td>
                  <td className="border border-gray-300 px-4 py-3 text-gray-900">
                    {employee.Code || 'N/A'}
                  </td>
                  <td className="border border-gray-300 px-4 py-3 text-gray-900">
                    {employee.Mobile || 'N/A'}
                  </td>
                  <td className="border border-gray-300 px-4 py-3 text-gray-900">
                    {employee.Email || 'N/A'}
                  </td>
                  <td className="border border-gray-300 px-4 py-3 text-gray-900">
                    {employee.DesignationName || 'N/A'}
                  </td>
                  {isAdmin == 1 &&
                    <td className="border border-gray-300 px-4 py-3 text-gray-900">
                      {employee.DepartmentName || 'N/A'}
                    </td>}
                  <td className="border border-gray-300 px-4 py-3 text-gray-900">
                    {employee.ProfitCenterName || 'N/A'}
                  </td>
                  <td className="border border-gray-300 px-4 py-3 text-gray-900">
                    {formatDate(employee.DOJ)}
                  </td>
                  <td className="border border-gray-300 px-4 py-3 text-gray-900">
                    {employee.CategoryName || 'N/A'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default NonWorkingEmp
